import LineString from "ol/geom/LineString";
import MultiLineString from "ol/geom/MultiLineString";
import {
  getNodeStyleNormal,
  getNodeStyleClick,
  getNodeStyleHover,
} from "./node";
import {
  getPropertyEndingWith,
  getPropertyEndingWithExcludingLayer7,
} from "./propertyExtraction";
import { roadClassBand, roadClassWire } from "./util/roadClassStrokes";

// Style of the RM Basemap 6 row (WFS of 21591): ways coloured by `highway=`, in the
// same palette as the LM basemap's road areas and lanes, so the RM road and the LM
// lanes built from it can be compared side by side.
//
// The Orbis `6-highway` wins over OSM's `7-highway` when both are on the way; the
// LM road class is copied from the Orbis RM road, so that is the one to match.

//
// Two views: the default wide translucent band, and a thin opaque wire of the same
// colour.

export function getRmRoadClassStyleNormal(feature) {
  return getRmRoadClassStyle(feature, roadClassBand, 10).concat(
    getNodeStyleNormal(feature),
  );
}
export function getRmRoadClassStyleClick(feature) {
  return getRmRoadClassStyle(feature, roadClassBand, 16).concat(
    getNodeStyleClick(feature),
  );
}
export function getRmRoadClassStyleHover(feature) {
  return getRmRoadClassStyle(feature, roadClassBand, 14).concat(
    getNodeStyleHover(feature),
  );
}

export function getRmWireStyleNormal(feature) {
  return getRmRoadClassStyle(feature, roadClassWire, 1.5).concat(
    getNodeStyleNormal(feature),
  );
}
export function getRmWireStyleClick(feature) {
  return getRmRoadClassStyle(feature, roadClassWire, 4).concat(
    getNodeStyleClick(feature),
  );
}
export function getRmWireStyleHover(feature) {
  return getRmRoadClassStyle(feature, roadClassWire, 3).concat(
    getNodeStyleHover(feature),
  );
}

function getRmRoadClassStyle(feature, line, width) {
  const geometry = feature.getGeometry();
  if (!(
    geometry instanceof LineString || geometry instanceof MultiLineString
  )) {
    return [];
  }
  const highway =
    getPropertyEndingWithExcludingLayer7(feature, "-highway") ??
    getPropertyEndingWith(feature, "-highway");
  return line(highway, width);
}
